/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Select_Guide_PromptInputs */

const en_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a KNP guide from the list or create a new one.`)
};

const fr_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un guide KNP dans la liste ou créez-en un nouveau.`)
};

const de_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen KNP-Führer aus der Liste aus oder erstellen Sie einen neuen.`)
};

const it_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una guida KNP dall'elenco o creane una nuova.`)
};

const ru_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите гида по КНП из списка или создайте нового.`)
};

const es_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una guía KNP de la lista o cree una nueva.`)
};

const zh_cn2_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从列表中选择一位克鲁格国家公园 (KNP) 导游，或者创建一个新的导游。`)
};

const ja_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リストから KNP ガイドを選択するか、新しいガイドを作成します。`)
};

const hi_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूची में से एक केएनपी गाइड चुनें या एक नया गाइड बनाएं।`)
};

const pt_pt2_knp_manager_select_guide_prompt = /** @type {(inputs: Knp_Manager_Select_Guide_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um guia do Parque Nacional Kruger na lista ou crie um novo.`)
};

/**
* | output |
* | --- |
* | "Select a KNP guide from the list or create a new one." |
*
* @param {Knp_Manager_Select_Guide_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_select_guide_prompt = /** @type {((inputs?: Knp_Manager_Select_Guide_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Select_Guide_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_select_guide_prompt(inputs)
	if (locale === "de") return de_knp_manager_select_guide_prompt(inputs)
	if (locale === "it") return it_knp_manager_select_guide_prompt(inputs)
	if (locale === "ru") return ru_knp_manager_select_guide_prompt(inputs)
	if (locale === "es") return es_knp_manager_select_guide_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_select_guide_prompt(inputs)
	if (locale === "ja") return ja_knp_manager_select_guide_prompt(inputs)
	if (locale === "hi") return hi_knp_manager_select_guide_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_select_guide_prompt(inputs)
	return en_knp_manager_select_guide_prompt(inputs)
});